import React from "react";

export const SearchFormattedData = props => {
  const formatdata = (data, highlights = Array([]), layer = 1) => {
    const list_items = [];
    let key = null;
    let value = null;
    for (var item in data) {
      key = <span style={{ fontWeight: "bold" }}>{item}:</span>;
      if (typeof data[item] === "object") {
        var new_layer = layer + 1;
        value = formatdata(data[item], highlights, new_layer);
      } else {
        value = JSON.stringify(data[item]);
      }

      list_items.push(
        layer === 1 ? (
          <li key={item} style={{ border: "1px solid gray" }}>
            {key}
            {value}
          </li>
        ) : (
          <li key={item} style={{ background: "white" }}>
            {key}
            {value}
          </li>
        )
      );

      key = null;
      value = null;
    }
    return <ul>{list_items}</ul>;
  };
  return <div>{formatdata(props.resource)}</div>;
};
